import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';
import { makeSelectClientDetails } from 'containers/Main/selectors';

const useStyles = makeStyles({
  root: {
    background: '#ffffff',
    color: '#4B4B4B',
    padding: 12,
    marginBottom: 5,
    fontFamily: 'MadaRegular',
    fontSize: '0.875rem',
    border: '1px solid #4B4B4B',
    '&:hover': {
      opacity: 0.8,
    },
  },
});

function SAMLButton({ onClick }) {
  const classes = useStyles();
  const clientDetails = useSelector(makeSelectClientDetails());

  const samlConfiguration = _get(clientDetails, 'samlConfiguration', {});
  const shouldDisplay = _get(samlConfiguration, 'enabled', false);
  const label = _get(samlConfiguration, 'label');
  const providerId = _get(samlConfiguration, 'providerId');

  if (!shouldDisplay || !providerId) return null;

  return (
    <ButtonBase className={classes.root} onClick={onClick}>
      {label}
    </ButtonBase>
  );
}

SAMLButton.propTypes = {
  onClick: PropTypes.func,
};

export default SAMLButton;
